import './_filter-category.scss';
import component from './filter-category';

export default component;
